// extracted by mini-css-extract-plugin
export default {"container":"CaseStateProgress_container__QYSCe","button":"CaseStateProgress_button__OlIm3"};